<template>
    <div class="let-main-menu">
        <el-button class="zhedie" @click="handlerFold">
            <ab-svg name="zdleft"></ab-svg>
        </el-button>
    
        <div class="menu-scroll" :style="{'height': (documentClientHeight - 156) + 'px'}">
            <el-menu
                :default-active="activeMenu"
                class="el-menu-vertical-left"
                ref="menus"
                :default-openeds="defaultMenu"
                :unique-opened="false"
                router
                @select="selectMenu"
                v-if="reload"
            >
            <!-- <el-menu-item :index="menu.url" v-for="menu in (menuList || []).filter(e => e.isShow && (e.url && !e.children))">
                <template #title>
                <ab-svg :name="menu.icon" ></ab-svg>
                <span>{{menu.name}}</span>
                </template>
            </el-menu-item> -->
            <el-sub-menu :class="[item.children.some(e=>mainTabsActiveName.indexOf(e.url) != -1) ? 'is-active' : 'no-active']" :index="item.id" v-for="(item,idx) in (menuList || []).filter(e => e.isShow && e.children && e.children.length)" :key="idx">
                <template #title>
                    <ab-svg :name="item.icon"></ab-svg>
                    <span>{{item.name}}</span>
                </template>
                <el-menu-item :class="[mainTabsActiveName.indexOf(chre.url) != -1 ? 'is-active' : 'no-active']" :index="chre.url" :key="chre" v-for="chre in item.children.filter(e => e.isShow)">{{chre.name}}</el-menu-item>
            </el-sub-menu>
            </el-menu>
            <div class="menu-footer">
                <p class="cut"></p>
                <img src="@/assets/img/qc.png"/>
                <p>扫描二维码</p>
                <p>掌握订单动态</p>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        data () {
            return {
                menuList: [],
                reload: true,
                defaultMenu: ['685807856716349440','685808854310584320','685810779705835520','685814401629945856','685814464968130560'],
                bizType: {}
                
            }
        },
        computed: {
            sidebarFold: {
                get () {
                    return this.$store.state.sidebarFold
                },
                set (val) {
                    this.$store.commit('updateSidebarFold', val)
                }
            },
            documentClientHeight: {
                get() {
                    return this.$store.state.documentClientHeight;
                },
                set(val) {
                    this.$store.commit('updateDocumentClientHeight', val);
                }
            },
            activeMenu: {
                get () {
                    return this.$store.state.activeMenu
                },
                set (val) {
                    this.$store.commit('updateActiveMenu', val)
                }
            },
            mainTabs: {
                get () { return this.$store.state.mainTabs },
                set (val) { this.$store.commit('updateMainTabs', val) }
            },
            mainTabsActiveName: {
                get () { return this.$store.state.mainTabsActiveName },
                set (val) { this.$store.commit('updateMainTabsActiveName', val) }
            },
            keepAliveView: {
                get () { return this.$store.state.keepAliveView },
                set (val) { this.$store.commit('updateKeepAliveView', val) }
            }
        },
        created() {
            this.getMenus()
        },
        mounted() {
            // setTimeout(() => {
                if (this.$route.path != '/' && this.$route.path != 'home') {
                    this.activeMenu = this.$route.path.replace('/', '')
                    this.setMainTabs({index: this.activeMenu, name: this.$route.name})
                    if (this.$route.path == '/my-list' || this.$route.meta.keepAlive || this.$route.meta.sidebarFold) {
                        this.sidebarFold = true
                    }
                } else {
                    this.setMainTabs({index: '/', name: '首页'})
                    this.sidebarFold = true
                }
            // }, 50)
            console.log(this.mainTabsActiveName)
        },
        methods: {
            getMenus () {
                this.bizType = JSON.parse(sessionStorage.getItem('bizType') || '{}')
                this.$post('/p/menu/queryTreeByUserIdAndAppId', {
                    userId: '',
                    businessType: 'CLIENT2',
                    bizTypeGroup: this.bizType.activeIndex
                }).then(({data}) => {
                    if (data && data.code === 'C0000') {
                        if(data.result.menuList.length > 0) {
                            let list = [data.result.menuList[0]]
                            this.menuList = list && list.length ? list[0].children : []
                            sessionStorage.setItem('permissions', JSON.stringify(data.result.permissions || '[]'))
                            if (this.bizType.activeIndex == '01') {
                                this.defaultMenu = ['685807856716349440','685808854310584320','685810779705835520','685814401629945856','685814464968130560']
                            } else if (this.bizType.activeIndex == '07') {
                                this.defaultMenu = ['695648524083134464', '698470636418236416']
                            } else if (this.bizType.activeIndex == '02') {
                                this.defaultMenu = ['774954194003034112', '753642504129085440', '685808854310584320', '685810779705835520', '685814464968130560','774977327795798016', '685814401629945856']
                            }
                            this.isReload()
                        }
                    }
                })
            },
            selectMenu (index, indexPath) {
                console.log(index)
                this.activeMenu = index
                this.getRouterName(index)
            },
            handlerFold () {
                this.sidebarFold = !this.sidebarFold
            },
            handlerOpen (val) {
               // this.oneLevelRouter(val)
            },
            handlerClose (key, keyPath) {
                this.$refs.menus.open(keyPath)
            },
            oneLevelRouter (val) {
                let menu = this.menuList[val]
                if (menu.url) {
                    this.$router.push({path: menu.url})
                    this.setMainTabs({index: menu.url, name: menu.name})
                    this.activeMenu = menu.url
                    this.mainTabsActiveName = menu.url
                }
    
            },
            getRouterName(index) {
                console.log(index)
                let obj = {
                    index: '', //routet path
                    name: '' // router name
                }
                for (let i = 0; i < this.menuList.length; i++) {
                    if (!this.menuList[i].url) {
                        for (let y = 0; y < this.menuList[i].children.length; y++) {
                            if (this.menuList[i].children[y].url == index) {
                                obj.index = index
                                obj.name = this.menuList[i].children[y].name
                                break
                            }
                        }
                    } else if (this.menuList[i].url == index) {
                        obj.index = index
                        obj.name = this.menuList[i].name
                        break
                    }
                }
                if (obj.name == '订单新增' || obj.name == '新增订单') {
                    if (this.bizType.activeIndex == '02') {
                        obj.name = '出口订单详情'
                    } else if (this.bizType.activeIndex == '01') {
                        obj.name = '进口订单详情'
                    }
                }
               this.setMainTabs(obj)
            },
            setMainTabs (obj) {
              let tab =  this.mainTabs.filter(item => item.name === obj.name)[0]
              if (!tab) {
                this.mainTabs = this.mainTabs.concat(obj)
              }
              let mainTabs = this.mainTabs.filter(item => item.name != '首页')
              mainTabs.unshift({index: '/', name: '首页'})
              this.mainTabs = mainTabs
              this.mainTabsActiveName = obj.index
              let viewTemp = []
              this.mainTabs.map(e => {
                    let view = e.index.replace('/', '')
                    if (view) {
                        viewTemp.push(view)
                    }
               })
              this.keepAliveView = viewTemp
            },
            isReload () {
                this.reload = false
                this.$nextTick(() => {
                    this.reload = true
                })
            },
        }
    }
    </script>
    
    <style lang="scss">
    .let-main-menu {
        position: relative;
        width: 174px;
        height: 100%;
        margin-left: 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 40px 0px rgba(0,0,0,0.1);
        border-radius: 8px;
        overflow: hidden;
        .zhedie {
            width: 174px;
            background-color: #FBFBFB;
            border: none;
            .icon-svg {
                width: 16px;
                height: 16px;
                color: #000000;
            }
            &:hover {
                background: #FBFBFB;
                .icon-svg {
                    color: #0a7cff;
                }
            }
        }
        .menu-scroll {
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
        }
        .el-menu-vertical-left {
            .icon-svg {
                width: 14px;
                height: 16px;
                margin-right: 10px;
                margin-left: 10px;
            }
            .el-sub-menu__title {
                .el-sub-menu__icon-arrow {
                    display: none;
                }
            }
            
        }
        .el-menu--inline {
            // display: block!important;
       }
        .el-menu--inline {
            .el-menu-item {
                padding-left: 47px!important;
                line-height: 40px;
                height: 40px;
            }
        }
        .el-menu .el-menu-item {
            line-height: 40px;
            height: 40px;
        }
        
        .el-sub-menu__title {
            height: 40px;
        }
        .menu-footer {
            padding: 20px;
            img {
                width: 120px;
                height: 120px;
                margin: 10px;
            }
            p {
                font-size: 12px;
                font-weight: 400;
                text-align: center;
            }
            .cut {
                border-bottom: 1px solid #D7DBE0;
                margin-bottom: 20px;
            }
        }
        .el-menu-item.is-active
       {
            background-color: #0a7cff;
            border-radius: 8px;
            font-size: 14px;
            // margin: 0 10px;
            // padding-left: 52px!important;
             color: #ffffff;
             font-weight: bold;
             &.no-active{
                background-color: #fff;
                color: #000000;
             }
        }
        .el-sub-menu.is-active {
            .el-sub-menu__title {
                color:#0a7cff;
            }
             &.no-active{
                .el-sub-menu__title {
                    color: #000000;
                }
             }
        }
        .el-sub-menu {
            .el-sub-menu__title {
                font-weight: bold;
            }
        }
        .el-menu {
            margin: 0 5px;
            background-color: #ffffff;
        }
        .el-sub-menu {
            .el-sub-menu__title {
                color: #04070D;
                border-radius: 8px;
            }
            
            .el-menu-item {
                border-radius: 8px;
                color: #535353;
            }
        }
        .el-sub-menu {
            .is-active {
                color: #ffffff;
            }
        }
       
    
    }
    </style>